export enum UserRole {
  SALES_REP = 'SalesRep',
  COLLECTOR = 'Collector',
  SUPERVISOR = 'Supervisor',
  PROMOTER = 'Promoter',
  SALES_REP_PROMOTER = 'SalesRepPromoter',
  MARKETING = 'Marketing',
  TRAINER = 'Trainer',
  MANAGER = 'Manager',
  HR = 'HR',
}
